import { render, staticRenderFns } from "./ModalLinkProgressChat.vue?vue&type=template&id=cbf9d98c"
import script from "./ModalLinkProgressChat.vue?vue&type=script&lang=ts"
export * from "./ModalLinkProgressChat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports